import IconResolver from "../../../shared/components/common/ui/IconResolver";
import StatusBadge from "../../../shared/components/common/ui/StatusBadge";

// helpers (idealmente compartilhados com Templates)
const compactCol = (extra = {}) => ({
  width: 80,
  sortable: false,
  filterable: false,
  ...extra,
});

const textCol = (extra = {}) => ({
  flex: 1,
  minWidth: 180,
  ...extra,
});

export const getChannelsColumns = () => [
  {
    field: "type",
    headerName: "Tipo",
    ...compactCol({
      renderCell: (params) => <IconResolver name={params.value} />,
    }),
  },

  {
    field: "instance_name",
    headerName: "Nome",
    ...textCol(),
  },

  {
    field: "sender",
    headerName: "Saída",
    ...textCol(),
  },

  {
    field: "status",
    headerName: "Status",
    ...textCol({
      filterable: true,
      renderCell: (params) => <StatusBadge status={params.value} />,
    }),
  },
];
